import { ClientConfigProductName } from '@frontend/vanilla/core';

export const PopularMultiBetsLoader = {
    id: 'popular-multi-bets',
    loaderFn: () => import(/* webpackChunkName: "ms-popular-multi-bets" */ './popular-multi-bets.feature'),
    product: ClientConfigProductName.SPORTS,
};
